import React, { Component } from 'react';
import styled from 'styled-components';
import { format } from 'date-fns';
import { DnDContext } from '../DnDContext'
import { StylesProvider } from '@material-ui/core';

const Container = styled.div`
    width: 100%;
    height: auto;
    flex-grow: 4;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
`

const Title = styled.div`
    font-size: 0.8rem;
    font-weight: normal !important;
    @media (min-width: 600px) {
        font-size: 1rem;
    }
`

const Subtitle = styled.div`
    font-size: 0.8rem !important;
    font-weight: normal !important;
    margin-bottom: 0.2rem;
    /* color: ${props => props.today && 'red'}; */
    background-color: ${props => props.today && 'var(--focus-color)'};
    padding: 0.3rem;
    border-radius: 50%;
    :hover {
        filter: brightness(var(--brightness));
    }
`

class DateHeader extends Component {
    static contextType = DnDContext
    render() {
        const { draggable, slotHandlers, extraProps } = this.context
        const styles = extraProps.styles

        const defaultStyles = {
            primaryColor: 'var(--primary-color)'
        }
        const updatedStyles = Object.assign({}, defaultStyles, styles)
        return (
            <Container onClick={this.props.onDrillDown}>
                <Subtitle styles={updatedStyles}
                    today={format(this.props.date, 'Y-MM-dd') === format(new Date(), 'Y-MM-dd')}>
                    {this.props.label}
                </Subtitle>
            </Container>
        )
    }
}

export default DateHeader